import React from 'react';

const BuildingBlocksMetering = () => {
  const blocks = [
    {
      id: 1,
      image: '/assets/AMI/3section-1.svg',
      title: 'Smart Meters',
      description: 'Enable real-time energy consumption tracking with high accuracy. Smart meters support remote monitoring, automated readings, and faster issue detection, forming the foundation of an intelligent metering ecosystem.'
    },
    {
      id: 2,
      image: '/assets/AMI/3section-2.svg',
      title: 'Meter Data Management System (MDMS)',
      description: 'Centralizes meter data for storage, processing, and analysis. MDMS supports accurate billing, regulatory reporting, and actionable insights to improve operational efficiency and decision-making.'
    },
    {
      id: 3,
      image: '/assets/AMI/3section-3.svg',
      title: 'Secure Communication Network',
      description: 'Ensures reliable, two-way data exchange between smart meters and utility systems. Built with secure protocols, it enables real-time data flow, remote commands, and seamless system interoperability.'
    }
  ];

  return (
    <section className="bg-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-4 md:py-8 lg:py-12">
        {/* Header */}
        <div className="text-center mb-2 md:mb-4">
          <h2 className="font-bold mb-4 md:mb-5">
            <span className="">The Building Blocks of an Intelligent </span>
            <span className="secondary-text">Metering Ecosystem</span>
          </h2>
          <p className="   max-w-4xl mx-auto px-4">
            AMI is designed as a modular, scalable architecture that seamlessly connects physical metering devices with 
            centralized digital platforms.
          </p>
        </div>
      </div>

      {/* Full Width Blue Background Section with Cards */}
      <div className="primary-bg py-10 md:py-12 lg:py-14">
        <div className="container mx-auto px-4 md:px-8 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-6 lg:gap-7">
            {blocks.map((block) => (
              <div
                key={block.id}
                className="bg-white rounded-xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 flex flex-col"
              >
                {/* Image */}
                <div className="relative h-44 md:h-48 overflow-hidden">
                  <img
                    src={block.image}
                    alt={block.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                </div>

                {/* Content */}
                <div className="p-2 md:p-3 flex-grow flex flex-col">
                  <h3 className="   font-bold mb-1 md:mb-2 text-center relative inline-block mx-auto">
                    {block.title}
                    {/* Underline from middle to end */}
                    <span className="absolute bottom-0 left-1/2 right-0 h-0.5 bg-primary" style={{ backgroundColor: 'var(--primary-color)' }} />
                  </h3>
                  <p className="text-gray-600 text-xs leading-relaxed text-center">
                    {block.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuildingBlocksMetering;